import React, {FC, ReactNode} from "react"
import {isString} from "lodash"

import {connect} from "@irati/store"
import ReduxState from "@irati/store/types/ReduxState"
import {H1} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"
import Button from "@irati/ui/src/Button"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import {FormattedMessage} from "@irati/utils/lang"
import {Para} from "@irati/ui/src/Labels"
import Loading from "@irati/ui/src/Loading"

import ModalHeaderImage from "./ModalHeaderImage"
import {Wrapper, ImageModal, StandardModal, Close, Buttons} from "./styled"

export interface Props {
  title: string,
  children: string | ReactNode,
  isMobile: boolean,
  onConfirm: () => void,
  onHide: () => void,
  critical?: boolean,
  image?: string,
  proceedButtonText?: string,
  dismissButtonText?: string,
  actions?: ReactNode,
  small?: boolean,
  mobileFullHeight?: boolean,
  customWidth?: number,
  load?: Promise<any> | null,
  hideActions?: boolean,
  noValidation?: boolean
}

const GenericModal: FC<Props> = ({
  critical,
  title,
  onHide,
  onConfirm,
  image,
  children,
  actions,
  proceedButtonText,
  dismissButtonText,
  isMobile,
  load,
  hideActions = false,
  noValidation = false,
  ...props
}) => {
  const Modal = image ? ImageModal : StandardModal
  const ConfirmButton = noValidation ? Button : ValidationButton

  return (
    <Modal {...props} onHide={critical ? () => {} : onHide} image={image}>
      {image && <ModalHeaderImage image={image} />}
      <Wrapper direction="column" justifyContent="space-between" width="100%">
        <div>
          {image && <Spacing marginTop={3} />}
          {title && <H1 marginBottom={2}>{title}</H1>}
          {!critical && <Close inline={false} onClick={onHide} />}
          {isString(children) ? (
            <Para marginBottom={2}>
              <FormattedMessage id={children} />
            </Para>
          ) : (
            children
          )}
        </div>
        {!hideActions &&
          (actions || (
            <div>
              <Buttons justifyContent="flex-end" alignItems="center">
                {!critical &&
                  <Button marginRight={isMobile ? undefined : 2} tertiary onClick={onHide}>
                    <FormattedMessage id={dismissButtonText} />
                  </Button>
                }
                <ConfirmButton primary onClick={onConfirm} load={load}>
                  <FormattedMessage id={proceedButtonText} />
                </ConfirmButton>
              </Buttons>
              <Spacing marginTop={1}>
                <Loading load={load} useLoader={false} />
              </Spacing>
            </div>
          ))}
      </Wrapper>
    </Modal>
  )
}

GenericModal.defaultProps = {
  proceedButtonText: "platform.button.save",
  dismissButtonText: "platform.button.goBack"
}

const mapStateToProps = ({mq}: ReduxState) => {
  return {
    isMobile: mq.lessThan.medium
  }
}

export default connect(mapStateToProps)(GenericModal)
